module.exports = __webpack_public_path__ + "img/cu.0b42edab.svg";